import { render, staticRenderFns } from "./InfoWrapperBox.vue?vue&type=template&id=15b32933&"
import script from "./InfoWrapperBox.vue?vue&type=script&lang=js&"
export * from "./InfoWrapperBox.vue?vue&type=script&lang=js&"
import style0 from "./InfoWrapperBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports